import { render, staticRenderFns } from "./MainLedgerPrintGFIPOD.vue?vue&type=template&id=70d5c958&scoped=true"
import script from "./MainLedgerPrintGFIPOD.vue?vue&type=script&lang=js"
export * from "./MainLedgerPrintGFIPOD.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerPrintGFIPOD.vue?vue&type=style&index=0&id=70d5c958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d5c958",
  null
  
)

export default component.exports